export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

export function isMobile() {
  return getMobileOperatingSystem() !== "unknown"
}

export function isIOS() {
  return getMobileOperatingSystem() === "iOS"
}

export function isAndroid() {
  return getMobileOperatingSystem() === "Android"
}

export function isDesktop() {
  return !isMobile()
}

export function element(obj, path) {
  const comps = path.split('/')
  var lastObj = obj
  for (let i = 0; i < comps.length; i++) {
    if (!lastObj) {
      return null
    }
    const comp = comps[i];
    if (comp.length > 0) {
      if (Array.isArray(lastObj)) {
        const index = parseInt(comp)
        if ((index === 0 && comp !== '0') || index >= lastObj.length) {
          return null
        }
      }
      lastObj = lastObj[comp]
    }
  }
  return lastObj
}

export function string(obj, path) {
  const item = element(obj, path)
  if (typeof item === 'number') {
    return '' + item
  }
  if (typeof item === 'string') {
    return item
  }
  return null
}

export function stringValue(obj, path) {
  var response = string(obj, path)
  if (!response) {
    response = ""
  }
  return response
}

export function number(obj, path) {
  const item = element(obj, path)
  if (typeof item === 'number') {
    return item
  }
  if (typeof item === 'string') {
    var response = Number(item)
    if (isNaN(response)) {
      response = null
    }
    return response
  }
  return null
}

export function numberValue(obj, path) {
  var response = number(obj, path)
  if (!response) {
    response = 0
  }
  return response
}

export function object(obj, path) {
  const item = element(obj, path)
  if (typeof item === 'object') {
    // if (Array.isArray(item)) {
    //   var response = {}
    //   for (let i = 0; i < item.length; i++) {
    //     response[''+i] = item[i];
    //   }
    //   return response
    // }
    return item
  }
  return null
}

export function objectValue(obj, path) {
  var response = object(obj, path)
  if (!response) {
    response = {}
  }
  return response
}

export function array(obj, path) {
  const item = element(obj, path)
  if (Array.isArray(item)) {
    return item
  }
  return null
}

export function arrayValue(obj, path) {
  var response = array(obj, path)
  if (!response) {
    response = []
  }
  return response
}


// WEBPACK FOOTER //
// ./src/utils/index.js